import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { enumWorkflowState } from '../../../dataObjects/enums';
import { IAudioLink } from '../../../dataObjects/models/digitalMedia/AudioLink';

const initialState: enumWorkflowState | null = null;

export const audioLinkDeleteStatusSlice = createSlice({
  name: 'audioLinkDeleteStatus',
  initialState: enumWorkflowState.None,
  reducers: {
    // action has a payload with IAudioLink
    audioLinkDeleteRequest: (state: enumWorkflowState | null, action: PayloadAction<IAudioLink>) => {
      // return the workflow state of 'Requested' to indicate that the operation has been requested
      return enumWorkflowState.Requested;
    },
    // action has a payload with the new enumWorkflowState value or null
    audioLinkDeleteStatusChange(state: enumWorkflowState | null, action) {
      // change status of process
      return action.payload;
    },
  },
})

// Action creators are generated for each function in reducer
export const { audioLinkDeleteRequest, audioLinkDeleteStatusChange } = audioLinkDeleteStatusSlice.actions;

// export the core reducer for the slice
export const audioLinkDeleteStatusReducer = audioLinkDeleteStatusSlice.reducer;

export default audioLinkDeleteStatusSlice.reducer;